import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CalendarPage } from "@/features/calendarpage/CalendarPage";

const search = z.object({
  view: z.enum(["month", "week", "day", "agenda"]).optional(),
});

export const Route = createFileRoute("/_app/calendar/")({
  validateSearch: search,
  component: () => <CalendarPage search={Route.useSearch()} />,
});
